export default __webpack_public_path__ + "static/media/close.a8a56bde.svg";